var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
export var TextInputVariants;
(function (TextInputVariants) {
    TextInputVariants["Borderless"] = "borderless";
})(TextInputVariants || (TextInputVariants = {}));
const TextInput = (_a) => {
    var { innerRef, variant, onChange } = _a, props = __rest(_a, ["innerRef", "variant", "onChange"]);
    const localRef = React.useRef(null);
    const inputRef = innerRef || localRef;
    useEffect(() => {
        var _a, _b;
        // Only update the DOM value directly when value prop changes and input exists
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            inputRef.current.value = (_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
        }
    }, [props.value]);
    let classNames = props.className || "p-2 w-full";
    if (variant !== TextInputVariants.Borderless) {
        classNames += " border focus:border-salmon-600 focus:border-2";
        if (props.highlighted) {
            classNames += " border-salmon-600";
        }
        else {
            classNames += " border-gray-300";
        }
    }
    return (_jsx("input", { type: props.isNumber ? "number" : "text", onChange: (ev) => { onChange(ev); }, defaultValue: props.value, ref: inputRef, className: classNames, placeholder: props.placeholder, disabled: props.disabled }));
};
export default TextInput;
